import {
  Box,
  Avatar,
  HStack,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
  Image,
  Link,
  Heading,
} from "@chakra-ui/react";
import logo from "../Images/logoMK.jpg";
import resumeUrl from "../Download/Madhukar_Kakade_fw19_1056_.pdf";

import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { useState } from "react";

const Links = ["About Me", "Skills", "Projects", "Contact"];

export default function Navbar({ pagesRef }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [visible, setvisible] = useState({ hove: "false", nav: "" });

  const handleHover = (link) => {
    setvisible({ ...visible, hove: link });
  };

  const handleResume = () => {
    window.open(
      "https://drive.google.com/file/d/1g8qF7mZT9Qn_2BhIxu4VLA8sKyL-VJGe/view",
      "_blank"
    );
  };
  // console.log(visible);
  return (
    <>
      <Box bg={useColorModeValue("gray.100", "gray.900")} px={12}>
        <HStack spacing="40px" h="60px" justify="space-between">
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />

          <Box>
            <Link
              to="/"
              onClick={() => {
                setvisible({ ...visible, nav: false });
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            >
              <Box w="50px">
                <Image w="100%" name="MK" src={logo} alt="home logo" />
              </Box>
            </Link>
          </Box>

          <HStack
            as={"nav"}
            spacing={["10px", null, "20px", null, "30px"]}
            display={{ base: "none", md: "flex" }}
            justify="space-between"
            alignItems={"center"}
            color="gray.500"
          >
            {Links.map((link) => (
              // <Link key={link} to={"/" + link.toLowerCase().split(" ", 1)}>
              <Box
                color={link == visible.nav ? "orange.400" : ""}
                onClick={(e) => {
                  setvisible({ ...visible, nav: link });
                  const name = e.target.innerText.split(" ")[0];

                  pagesRef.current[name]?.scrollIntoView({
                    behavior: "smooth",
                  });
                }}
                onMouseEnter={() => handleHover(link)}
                onMouseLeave={() => handleHover(false)}
                _before={{
                  content: '""',
                  position: "absolute",
                  backgroundColor:
                    link === visible.nav ? "blue.500" : "blue.200",
                  height: " 2px",
                  // top= "100%"
                  width:
                    link === visible.hove || link === visible.nav
                      ? "100%"
                      : "0%",
                  left: "50%",
                  bottom: "-10px",
                  transition: " width .3s, ease-in-out   transform",
                  transform: "translate(-50%, -50%)",
                }}
                position="relative"
              >
                <Heading size={["xs", null, "sm", null, "md"]}>{link}</Heading>
              </Box>
              // </Link>
            ))}
            <Link href={resumeUrl} download>
              <Button
                onClick={handleResume}
                fontSize={["xs", "sm", "md", "lg", "xl"]}
                fontWeight="bold"
              >
                Resume
              </Button>
            </Link>
            <Avatar
              size={"md"}
              src={
                "https://ca.slack-edge.com/T049JC010P9-U04ARFKMAHL-92937c2b8633-72"
              }
            />
          </HStack>
        </HStack>
        <Box>
          {isOpen ? (
            <Box pb={4} display={{ md: "none" }}>
              <Stack as={"nav"} spacing={4}>
                {Links.map((link) => (
                  <Box
                    key={link}
                    onClick={(e) => {
                      setvisible({ ...visible, nav: link });
                      const name = e.target.innerText.split(" ")[0];

                      pagesRef.current[name]?.scrollIntoView({
                        behavior: "smooth",
                      });
                      onClose();
                    }}
                    _hover={{ bg: "orange.100" }}
                    color={link == visible.nav ? "orange.400" : ""}
                  
                  >
                    {link}
                  </Box>
                ))}
                <Link href={resumeUrl} download>
                  <Button
                    onClick={() => {
                      handleResume();
                      onClose();
                    }}
                    fontSize={["md", "lg", "xl"]}
                  >
                    Resume
                  </Button>
                </Link>
              </Stack>
            </Box>
          ) : null}
        </Box>
      </Box>
    </>
  );
}
